import { render, staticRenderFns } from "./MfaSettings.vue?vue&type=template&id=70860042&scoped=true"
import script from "./MfaSettings.vue?vue&type=script&lang=js"
export * from "./MfaSettings.vue?vue&type=script&lang=js"
import style0 from "./MfaSettings.vue?vue&type=style&index=0&id=70860042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70860042",
  null
  
)

export default component.exports